<div class="header">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <button class="dialog-close" mat-icon-button [mat-dialog-close]="false" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content *ngIf="data.dialogType!='E'">
  <p>{{data.message}}</p>
  <p>{{data.message2}}</p>
</div>

<div mat-dialog-content *ngIf="data.dialogType=='E'" style="color: brown;">
  <p>{{data.message}}</p>
  <p>{{data.message2}}</p>
</div>

<div style="height: 20px;"></div>

<div mat-dialog-actions [align]="'end'" *ngIf="data.showConfirmBox">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{data.confirmText}}
  </button>
  <button mat-raised-button [mat-dialog-close]="false">
      {{data.cancelText}}
  </button>
</div>

<div mat-dialog-actions [align]="'end'" *ngIf="!data.showConfirmBox">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{data.confirmText}}
  </button>
</div>
